<div class="d-flex justify-content-between align-items-center w-100 mt-1">
	<p class="mt-3 mb-0 text-muted fw-700">Solicitações</p>
	<div>
		<button class="btn btn-sm btn-icon me-3" (click)="fetchSessionMessages()"><fa-icon icon="refresh"></fa-icon></button>
	</div>
</div>

<hr class="mt-0">

@if (sessionMessage$ | async; as messages) {
	@if (messages.length === 0) {
		<div class="d-flex align-items-center justify-content-center w-100" style="height: 50vh;">
			<app-empty-data message="Nenhum esclarecimento ou impugnação encontrado..."></app-empty-data>
		</div>
	} @else {
		<ul class="list-group list-group-flush">
			@for (item of messages; track item.id) {
				<li class="list-group-item bg-white ps-0 pe-0 mb-3 mt-3">
					<div class="d-flex flex-column">
						@if (item.submitted) {
							<app-pre-loading [inline]="true" [large]="false" msg="Baixando, aguarde"></app-pre-loading>
						} @else {
							<div class="message-bubble system align-self-start"
								 [class.cursor-pointer]="item.hasAttachment"
								 (click)="messageAttachmentDownload(item, item.id)"
								 [ngbTooltip]="item.hasAttachment ? 'Clique para baixar' : ''" [innerHTML]="item.supplierMessageChat"></div>

							@if (item.comment) {
								@if (item.comment.submitted) {
									<app-pre-loading [inline]="true" [large]="false" msg="Baixando, aguarde"></app-pre-loading>
								} @else {
									<div class="d-flex justify-content-end mb-4">
										<div class="message-bubble user align-self-end"
											 [class.cursor-pointer]="item.comment.hasAttachment"
											 (click)="messageAttachmentDownload(item.comment, item.comment.id)"
											 [ngbTooltip]="item.comment.hasAttachment ? 'Clique para baixar' : ''"
											 [innerHTML]="item.agentMessageChat"></div>
									</div>
								}
							} @else {
								<div class="d-flex justify-content-end w-100">
									<button *permissions="'dispute.session-message.create'" class="btn btn-link" (click)="modalSessionMessage(item)" [disabled]="demand?.statusCanceled">
										<fa-icon icon="reply" class="me-1"></fa-icon> Responder
									</button>
								</div>
							}
						}
					</div>
				</li>
			}
		</ul>
	}
} @else {
	<div class="d-flex align-items-center justify-content-center w-100" style="height: 50vh;">
		<app-pre-loading></app-pre-loading>
	</div>
}

<!--Modal request messages-->
<ng-template #modalRequestMessage let-modal>
	<div class="modal-header">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<h4 class="modal-title" id="modal-basic-title">Responde Solicitação</h4>
			<div class="d-flex align-items-center">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<div class="row p-2">
			<div class="col-md-12 mb-3">
				<div class="col-md-12">
					<label for="message" class="form-label">Mensagem</label>
					<textarea class="form-control" style="height: 100px;" [formControl]="sessionMessageControl"></textarea>
				</div>
			</div>
			<div class="col-md-12 mb-3">
				<div class="col-md-12">
					<label for="referenceTerm" class="form-label">Anexe o documento em PDF</label>
					<input class="form-control form-control-lg" (change)="onSessionAttachmentSelected($event)" id="referenceTerm" type="file" [disabled]="submitted">
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<div class="d-flex justify-content-end">
			<button *permissions="'dispute.session-message.create'" class="btn btn-primary" (click)="saveMessage()" [disabled]="submitted">
				<app-label-loading-dots [loading]="submitted" label="Salvar"></app-label-loading-dots>
			</button>
		</div>
	</div>
</ng-template>

<!--Modal view document-->
<ng-template #modalAttachmentView let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ attachmentTitle ?? 'Anexo' }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body m-0 p-0 overflow-y-hidden">
		@if (attachmentLoading) {
			<div class="d-flex h-100 align-items-center justify-content-center">
				<app-pre-loading></app-pre-loading>
			</div>
		} @else {
			@if (attachmentUrl) {
				@if(attachmentUrl === 'error') {
					<div class="d-flex h-100 align-items-center justify-content-center">
						<app-empty-data message="Não foi possível baixar o documento..."></app-empty-data>
					</div>
				} @else {
					<iframe [src]="attachmentUrl" width="100%" height="100%" [frameBorder]="0"></iframe>
				}
			}
		}
	</div>
</ng-template>
